import React, {useEffect, useMemo, useState} from 'react'
import { useSnackbar } from 'notistack'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../../redux/actions/user'
import { useStyles } from './FormContactUrgentStyle'
import TabNavigation from '../../TabNavigation/TabNavigation'

//Material UI
import FormHelperText from '@material-ui/core/FormHelperText'
import MenuItem from '@material-ui/core/MenuItem'
import {Accordion, AccordionDetails, AccordionSummary, Alert, Divider, FormControl} from '@mui/material'
import { TextField } from '@mui/material'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@mui/material/Typography'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import FormAdressContact from "../FormContactAdress/FormAdressContact";


export default function FormContactUrgent(props) {

  const dispatch = useDispatch()
  const classes = useStyles()
  const { formClass, defaultValues, refresh, pays, adresseTypes, postCodes, liensQualite, id, nextTab, previousTab, dateNaiss } = props
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  const [prefixe1, setPrefixe1] = useState(defaultValues.contacts[0]?.CONTURG_ADRESSEBISTER ?? '')
  const [adresseType1, setAdresseType1] = useState(defaultValues.contacts[0]?.CONTURG_TERM_ID ?? '')
  const [paysId, setPaysId] = useState(defaultValues.contacts[0]?.CONTURG_PAYS_ID ?? '')
  const [prefixe2, setPrefixe2] = useState(defaultValues.contacts[1]?.CONTURG_ADRESSEBISTER ?? '')
  const [adresseType2, setAdresseType2] = useState(defaultValues.contacts[1]?.CONTURG_TERM_ID ?? '')
  const [paysId2, setPaysId2] = useState(defaultValues.contacts[1]?.CONTURG_PAYS_ID ?? '')

  const [isContact1Filled, setIsContact1Filled] = useState(false);
  const [isContact2Filled, setIsContact2Filled] = useState(false);

  const [isAddress1Filled, setIsAddress1Filled] = useState(false);
  const [isAddress2Filled, setIsAddress2Filled] = useState(false);

  const { register, handleSubmit, errors, watch, getValues, control, setValue } = useForm({
    defaultValues: {
      contacts: [
        {
          CONTURG_NOM: defaultValues.contacts[0].CONTURG_NOM,
          CONTURG_PRENOM: defaultValues.contacts[0].CONTURG_PRENOM,
          CONTURG_TELPORTABLE: defaultValues.contacts[0].CONTURG_TELPORTABLE,
          CONTURG_LIENQUAL_ID: defaultValues.contacts[0].CONTURG_LIENQUAL_ID ?? '',
          CONTURG_ADRESSE1: defaultValues.contacts[0].CONTURG_ADRESSE1 ?? '',
          CONTURG_ADRESSE2: defaultValues.contacts[0].CONTURG_ADRESSE2 ?? '',
          CONTURG_ADRESSE3: defaultValues.contacts[0].CONTURG_ADRESSE3 ?? '',
          CONTURG_ADRESSEBISTER: defaultValues.contacts[0].CONTURG_ADRESSEBISTER ?? '',
          CONTURG_BATIMENT: defaultValues.contacts[0].CONTURG_BATIMENT ?? '',
          CONTURG_CP: defaultValues.contacts[0].CONTURG_CP ?? '',
          CONTURG_ESCALIER: defaultValues.contacts[0].CONTURG_ESCALIER ?? '',
          CONTURG_PAYS_ID: defaultValues.contacts[0].CONTURG_PAYS_ID ?? '',
          CONTURG_VILLE: defaultValues.contacts[0].CONTURG_VILLE ?? '',
          CONTURG_TERM_ID: defaultValues.contacts[0].CONTURG_TERM_ID ?? '',
        },
        {
          CONTURG_NOM: defaultValues.contacts[1].CONTURG_NOM,
          CONTURG_PRENOM: defaultValues.contacts[1].CONTURG_PRENOM,
          CONTURG_TELPORTABLE: defaultValues.contacts[1].CONTURG_TELPORTABLE,
          CONTURG_LIENQUAL_ID: defaultValues.contacts[1].CONTURG_LIENQUAL_ID ?? '',
          CONTURG_ADRESSE1: defaultValues.contacts[1].CONTURG_ADRESSE1 ?? '',
          CONTURG_ADRESSE2: defaultValues.contacts[1].CONTURG_ADRESSE2 ?? '',
          CONTURG_ADRESSE3: defaultValues.contacts[1].CONTURG_ADRESSE3 ?? '',
          CONTURG_ADRESSEBISTER: defaultValues.contacts[1].CONTURG_ADRESSEBISTER ?? '',
          CONTURG_BATIMENT: defaultValues.contacts[1].CONTURG_BATIMENT ?? '',
          CONTURG_CP: defaultValues.contacts[1].CONTURG_CP ?? '',
          CONTURG_ESCALIER: defaultValues.contacts[1].CONTURG_ESCALIER ?? '',
          CONTURG_PAYS_ID: defaultValues.contacts[1].CONTURG_PAYS_ID ?? '',
          CONTURG_VILLE: defaultValues.contacts[1].CONTURG_VILLE ?? '',
          CONTURG_TERM_ID: defaultValues.contacts[1].CONTURG_TERM_ID ?? '',
        }
      ],
    },

  })
  const { enqueueSnackbar } = useSnackbar()

  const isChild = useMemo(() => getAgeFromBirthDate(dateNaiss) < 18, [dateNaiss])

  function getAgeFromBirthDate(date) {
    const today = new Date()
    const birthDate = new Date(date)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  function getFullNameCity(cityNameWithPostalCode) {
    return cityNameWithPostalCode?.split('(')[0].trim()
  }

  function isContactUrgentIsFilled(numContact) {
    return watch(`contacts.${numContact}.CONTURG_NOM`) !== '' && watch(`contacts.${numContact}.CONTURG_PRENOM`) !== '' && watch(`contacts.${numContact}.CONTURG_TELPORTABLE`) !== '' && watch(`contacts.${numContact}.CONTURG_LIENQUAL_ID`) !== '';
  }

  function checkIfContactUrgentIsFilled(numContact) {
    return isContactUrgentIsFilled(numContact) && watch(`contacts.${numContact}.CONTURG_ADRESSE1`) !== '' && watch(`contacts.${numContact}.CONTURG_ADRESSE2`) !== '' && watch(`contacts.${numContact}.CONTURG_CP`) !== '' && watch(`contacts.${numContact}.CONTURG_VILLE`) !== null && ((numContact === 0 && ((prefixe1 !== '' && adresseType1 !== '' && paysId !== null)) || (numContact === 1 && (prefixe2 !== '' && adresseType2 !== '' && paysId2 !== null))))
  }

  function displayInfoIfPrincipalContactIsFilled(numContact) {
    return isContactUrgentIsFilled(numContact) && !checkIfContactUrgentIsFilled(numContact);
  }

  const contact1Fields = watch([
    'contacts.0.CONTURG_NOM',
    'contacts.0.CONTURG_PRENOM',
    'contacts.0.CONTURG_TELPORTABLE',
    'contacts.0.CONTURG_LIENQUAL_ID',
  ])

  const contactAdress1Fields = watch([
    'contacts.0.CONTURG_CP',
    'contacts.0.CONTURG_VILLE',
    'contacts.0.CONTURG_TERM_ID',
    'contacts.0.CONTURG_ADRESSE1',
    'contacts.0.CONTURG_ADRESSE2',
  ]);

  const contact2Fields = watch([
    'contacts.1.CONTURG_NOM',
    'contacts.1.CONTURG_PRENOM',
    'contacts.1.CONTURG_TELPORTABLE',
    'contacts.1.CONTURG_LIENQUAL_ID',
  ]);

  const contactAdress2Fields = watch([
    'contacts.1.CONTURG_CP',
    'contacts.1.CONTURG_VILLE',
    'contacts.1.CONTURG_TERM_ID',
    'contacts.0.CONTURG_ADRESSE1',
    'contacts.0.CONTURG_ADRESSE2',
  ]);

  useEffect(() => {
    setIsContact1Filled(isContactUrgentIsFilled(0))
    setIsContact2Filled(isContactUrgentIsFilled(1))
  }, [contact1Fields, contact2Fields]);

  useEffect(() => {
    setIsAddress1Filled(checkIfContactUrgentIsFilled(0))
    setIsAddress2Filled(checkIfContactUrgentIsFilled(1))
  }, [contactAdress1Fields, contactAdress2Fields, prefixe2, prefixe1, adresseType1, adresseType2, paysId, paysId2]);

  async function save(data, e) {
    data = { ...data, category: 6 }
    data.contacts[0].CONTURG_ID = defaultValues.contacts[0].CONTURG_ID
    data.contacts[0].CONTURG_ADRESSEBISTER = prefixe1
    data.contacts[0].CONTURG_CP = watch('contacts.0.CONTURG_CP')
    data.contacts[0].CONTURG_PAYS_ID = watch('contacts.0.CONTURG_PAYS_ID')
    data.contacts[0].CONTURG_VILLE = getFullNameCity(watch('contacts.0.CONTURG_VILLE'))
    data.contacts[0].CONTURG_TERM_ID = adresseType1

    data.contacts[1].CONTURG_ID = defaultValues.contacts[1].CONTURG_ID
    data.contacts[1].CONTURG_ADRESSEBISTER = prefixe2
    data.contacts[1].CONTURG_CP = watch('contacts.1.CONTURG_CP')
    data.contacts[1].CONTURG_PAYS_ID = watch('contacts.1.CONTURG_PAYS_ID')
    data.contacts[1].CONTURG_VILLE = getFullNameCity(watch('contacts.1.CONTURG_VILLE'))
    data.contacts[1].CONTURG_TERM_ID = adresseType2

    const result = await allActions.fetchPostAPI(`api/users/modifs-infos-perso/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar('Enregistré !', { variant: `success` })
    refresh(result.json.data)

    const action = e.nativeEvent.submitter.dataset.action
    if (action === 'previous' && previousTab) previousTab()
    else if (action === 'next') nextTab()
  }

  const updateContactInfo = (contactIndex, contactData) => {
    Object.keys(contactData).forEach(key => {
      if (key === 'CONTURG_ADRESSEBISTER' && contactIndex === 0) {
        setPrefixe1(contactData[key])
      }
      if (key === 'CONTURG_ADRESSEBISTER' && contactIndex === 1) {
        setPrefixe2(contactData[key])
      }
      if (key === 'CONTURG_TERM_ID' && contactIndex === 0) {
        setAdresseType1(contactData[key])
      }
      if (key === 'CONTURG_TERM_ID' && contactIndex === 1) {
        setAdresseType2(contactData[key])
      }
      if (key === 'CONTURG_PAYS_ID' && contactIndex === 0) {
        setPaysId(contactData[key])
      }
      if (key === 'CONTURG_PAYS_ID' && contactIndex === 1) {
        setPaysId2(contactData[key])
      }
      setValue(`contacts.${contactIndex}.${key}`, contactData[key])
    })
  }

  const handleError = (error) => {
    if (error) {
      enqueueSnackbar('Erreur: ' + error, { variant: `error` })
    }
  }

  return (
    <form onSubmit={handleSubmit(save)}>
      <div className={formClass}>
        {displayInfoIfPrincipalContactIsFilled(0) && <Alert severity="warning" sx={{ marginBottom: 2 }}>
          <Typography variant="body2">Vous avez commencé à remplir les informations du 1er contact d'urgence. Veuillez remplir les informations de l'adresse pour valider les informations.</Typography>
        </Alert>}

        <h4 className={classes.title}>1er contact d'urgence</h4>
        <div className={classes.line}>

          <TextField
            label="Nom"
            className={classes.name}
            variant="outlined"
            type="text"
            name="contacts.0.CONTURG_NOM"
            margin="dense"
            inputRef={register}
            size="small"
            required={isChild}
          />

          <TextField
            label="Prénom"
            className={classes.name}
            variant="outlined"
            type="text"
            name="contacts.0.CONTURG_PRENOM"
            margin="dense"
            inputRef={register}
            size="small"
            required={isChild}
          />

          <div>
            <TextField
              label="Téléphone"
              variant="outlined"
              type="number"
              name="contacts.0.CONTURG_TELPORTABLE"
              margin="dense"
              inputRef={register({ minLength: 10, maxLength: 10, })}
              error={(errors.CONTURG_TELPORTABLE !== undefined)}
              size="small"
              required={isChild}
            />
            {errors.contacts && errors.contacts[0]?.CONTURG_TELPORTABLE && <FormHelperText error>Le numéro doit contenir 10 chiffres</FormHelperText>}
          </div>


          <FormControl
            {...register('contacts.0.CONTURG_LIENQUAL_ID')}
            style={{
              display: 'block',
              height: '-webkit-fill-available',
              marginTop: '8px',
              marginBottom: '4px',
            }}>
            <Controller

              as={
                <TextField
                  select
                  label={'Lien'}
                  sx={{ width: 230 }}
                  size="small"
                  required={isChild}
                >
                  {liensQualite.map((l, i) => (<MenuItem value={l.id} key={i}>{l.libelle} </MenuItem>))}
                </TextField>
              }
              name={'contacts.0.CONTURG_LIENQUAL_ID'}
              control={control}
            />
          </FormControl>
        </div>

        {isContact1Filled && <div className={classes.line + ' ' + classes.accordion}>
          <Accordion className={"accordion-contact"}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <HomeOutlinedIcon />
              <Typography className={classes.heading}>Adresse</Typography>
              <Typography className={classes.secondaryHeading}>Complément d'adresse du 1er contact</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormAdressContact
                register={register}
                errors={errors}
                formAdressNumber={0}
                errorsForm={handleError}
                save={(data) => updateContactInfo(0, data)}
                formClass={classes.form}
                defaultValues={defaultValues.contacts[0]}
                postCodes={postCodes}
                pays={pays}
                adresseTypes={adresseTypes} />
            </AccordionDetails>
          </Accordion>
        </div>}

        <Divider sx={{ marginBlock: 2 }} />

        {displayInfoIfPrincipalContactIsFilled(1) && <Alert severity="warning" sx={{ marginBottom: 2}}>
          <Typography variant="body2">Vous avez commencé à remplir les informations du 2eme contact d'urgence. Veuillez remplir les informations de l'adresse pour valider les informations.</Typography>
        </Alert>}

        <h4 className={classes.title}>2eme contact d'urgence</h4>
        <div className={classes.line}>

          <TextField
            label="Nom"
            className={classes.name}
            variant="outlined"
            type="text"
            name="contacts.1.CONTURG_NOM"
            margin="dense"
            inputRef={register}
            size="small"
            required={isChild}
          />

          <TextField
            label="Prénom"
            className={classes.name}
            variant="outlined"
            type="text"
            name="contacts.1.CONTURG_PRENOM"
            margin="dense"
            inputRef={register}
            size="small"
            required={isChild}
          />

          <div>

            <TextField
              label="Téléphone"
              variant="outlined"
              type="number"
              name="contacts.1.CONTURG_TELPORTABLE"
              margin="dense"
              inputRef={register({ minLength: 10, maxLength: 10, })}
              error={(errors.CONTURG_TELPORTABLE !== undefined)}
              size="small"
              required={isChild}
            />
            {errors.contacts && errors.contacts[1]?.CONTURG_TELPORTABLE && <FormHelperText error>Le numéro doit contenir 10 chiffres</FormHelperText>}
          </div>


          <FormControl {...register('contacts.1.CONTURG_LIENQUAL_ID')} style={{
            display: 'block',
            height: '-webkit-fill-available',
            marginTop: '8px',
            marginBottom: '4px',
          }}>
            <Controller
              as={
                <TextField
                  select
                  label={'Lien'}
                  sx={{ width: 230 }}
                  size="small"
                  required={isChild}
                >
                  {liensQualite.map((l, i) => (<MenuItem value={l.id} key={i}>{l.libelle} </MenuItem>))}
                </TextField>
              }
              name={'contacts.1.CONTURG_LIENQUAL_ID'}
              control={control}
            />
          </FormControl>
        </div>

        {isContact2Filled && <div className={classes.line + ' ' + classes.accordion}>
          <Accordion className={"accordion-contact"}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
              <HomeOutlinedIcon />
              <Typography className={classes.heading}>Adresse</Typography>
              <Typography className={classes.secondaryHeading}>Complément d'adresse du 2eme contact</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormAdressContact formAdressNumber={1} register={register} errors={errors} errorsForm={handleError} save={(data) => updateContactInfo(1, data)} formClass={classes.form} defaultValues={defaultValues.contacts[1]} postCodes={postCodes} pays={pays} adresseTypes={adresseTypes} />
            </AccordionDetails>
          </Accordion>
        </div>}

      </div>
      <TabNavigation disabled={!(isContact1Filled === isAddress1Filled && isContact2Filled === isAddress2Filled)} save previous/>
    </form>
  )
}
